// extracted by mini-css-extract-plugin
export default {"cards":"CityCards_cards__6yoCq"};